// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"5f3ce246","198":"9ef76e29","258":"25c9322e","275":"7a463e59","348":"f347f9f0","517":"4a03fb1f","597":"ddcc237c","626":"766b894c","790":"c1bd4683","942":"dd7eae18"}[chunkId] + ".chunk.js";
};